import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
class Period extends Component {
    constructor(props) {
        super();
        this.state = {
            year: props.year,
            month: props.month,
            personDocumentId: props.person_document_id,
            personProviderId: props.person_provider_id,
            items: [],
            page: 1,
            total: 0,
            maxRecords: 10,
        };
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    componentDidMount() {
        this.getData()

        moment.locale("es");
    }

    async getData(){
        

        const res = await axios.post('/api/period',{
            year:this.state.year,
            month:this.state.month,
            person_document_id:this.state.personDocumentId,
            person_provider_id:this.state.personProviderId,
            page:this.state.page,
        });
        this.setState({items: res.data.data, total: res.data.total});
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getData();
        });
    }

    render() {
        return (
            <>
                <div className="border-top border-primary"></div>

                <div className="p-6 mb-4">
                    <div className="mb-4 font-weight-bold">
                        Periodo: <strong className="text-dark">{moment(this.state.month, 'M').format('MMMM')} {this.state.year}</strong>
                    </div>

                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="border-0"></th>
                                    <th className="border-0">Nombre</th>
                                    <th className="border-0">Periodo</th>
                                    <th className="border-0">RFC</th>
                                    <th className="border-0">Total</th>
                                    <th className="border-0">Subtotal</th>  
                                    <th className="border-0">Moneda</th>
                                    <th className="border-0">Lugar Expedición</th>
                                    
                                    <th className="border-0">Fecha</th>
                                    <th className="border-0">Folio</th>
                                    <th className="border-0">Serie</th>
                                    <th className="border-0">Version</th>   

                                    <th className="border-0">Certificado</th>
                                    <th className="border-0">Sello</th>
                                    <th className="border-0">No. Certificado</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map((row, i) => (
                                <tr key={i}>
                                    <td> 
                                        <i className="flaticon-list-2 text-primary font-size-lg"></i>
                                    </td>
                                    <td className="text-dark-75 font-weight-bolder text-nowrap">{row.name} 
                                    </td>
                                    <td className="text-muted font-weight-bold">{row.month} / {row.year} </td>
                                    <td className="text-muted font-weight-bold">{row.rfc}</td>
                                    <td className="text-muted font-weight-bold">{row.total}</td>
                                    <td className="text-muted font-weight-bold">{row.subtotal}</td> 
                                    <td className="text-muted font-weight-bold">{row.moneda}</td>
                                    <td className="text-muted font-weight-bold">{row.lugar_expedicion}</td>
                                    
                                    <td className="text-muted font-weight-bold">{row.fecha}</td>
                                    <td className="text-muted font-weight-bold">{row.folio}</td>
                                    <td className="text-muted font-weight-bold">{row.serie}</td>
                                    <td className="text-muted font-weight-bold">{row.version}</td> 

                                    <td className="text-muted font-weight-bold">{row.certificado}</td>
                                    <td className="text-muted font-weight-bold">{row.sello}</td>
                                    <td className="text-muted font-weight-bold">{row.no_certificado}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    <SimplePagination
                        updateCurrentPage={this.updateCurrentPage}
                        currentPage={this.state.page}
                        totalFiles={this.state.total}
                        split={this.state.maxRecords}
                    />
                </div>
            </>
        );
    }
}

export default Period;

if (document.getElementById('Period')) {
    ReactDOM.render(<Period />, document.getElementById('Period'));
}
